(function (angular) {
	'use strict';

	const template = `<pmt-elm
			module="LocationSelectorPort"
			args="$ctrl.args"
			subscriptions="$ctrl.subscriptions"
		></pmt-elm>`;

	angular.module('PinMeTo.selectors').component('pmtLocationSelector', {
		template: template,
		controller: Controller,
		bindings: {
			siteName: '<',
			realm: '<',
			network: '<?',
			target: '<?',
			selectedLocations: '<',
			onSelected: '<'
		}
	});

	Controller.$inject = [];

	function Controller() {
		const $ctrl = this;

		$ctrl.args = {
			siteName: $ctrl.siteName,
			realm: $ctrl.realm,
			network: $ctrl.network || '',
			target: $ctrl.target || '',
			selected: $ctrl.selectedLocations || []
		};

		$ctrl.subscriptions = [
			{
				id: 'LocationsSelected',
				f: $ctrl.onSelected
			}
		];
	}
})(window.angular);
